/**
 * @file Entitled Photos Identity Filter Actions.
 */
export const TOGGLE_IDENTITY = 'entitled-photos-identities/TOGGLE_IDENTITY';
export const RESET = 'entitled-photos-identities/RESET';

export const toggleIdentity = identity => {
  return { type: TOGGLE_IDENTITY, identity };
};

export const reset = () => {
  return { type: RESET };
};
